import './index.less';

import RouteView from './RouteView.vue';
import Layout from './Layout.vue';
import LayoutBasic from './LayoutBasic.vue';

Layout.install = function install(Vue) {
  Vue.component(RouteView.name, RouteView);
  Vue.component(Layout.name, Layout);
  Vue.component(LayoutBasic.name, LayoutBasic);
};

export default Layout;
